// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tips[data-v-f335073a] {\n  color: #909399;\n  font-size: 12px;\n  line-height: 20px;\n  margin-bottom: 12px;\n}\n.pager[data-v-f335073a] {\n  margin-top: 12px;\n  text-align: right;\n}\n.selWidthSm[data-v-f335073a] {\n  width: 130px;\n}\n.selWidth[data-v-f335073a] {\n  width: 200px;\n}\n.goods-line[data-v-f335073a] {\n  color: #606266;\n  font-size: 12px;\n  line-height: 18px;\n}\n.muted[data-v-f335073a] {\n  color: #909399;\n  font-size: 12px;\n}", ""]);
// Exports
module.exports = exports;
